import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import { APP_METADATA } from '../../config/constants';
import PageLayout from '../../components/PageLayout/PageLayout';
import InfoCard from '../../components/InfoCard/InfoCard';
import { volunteeringData } from '../../data/volunteeringData';

const Volunteering = () => {
  useSEO({
    title: 'Volunteering',
    description: `Volunteering and community involvement of ${APP_METADATA.author}`,
    keywords: `${APP_METADATA.keywords}, Volunteering, Community Service`,
  });

  return (
    <PageLayout title="Volunteering" showTabs>
      <div className="gallery gallery--image">
        {volunteeringData.map((volunteering) => (
          <InfoCard
            key={volunteering.id}
            image={volunteering.image}
            imageAlt={volunteering.imageAlt}
            title={volunteering.title}
            subtitle={volunteering.subtitle}
            date={volunteering.date}
            description={volunteering.description}
          />
        ))}
      </div>
    </PageLayout>
  );
};

export default Volunteering;

